import { render, staticRenderFns } from "./assignJurisdiction.vue?vue&type=template&id=e6f25ac2&"
import script from "./assignJurisdiction.vue?vue&type=script&lang=js&"
export * from "./assignJurisdiction.vue?vue&type=script&lang=js&"
import style0 from "./assignJurisdiction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports